module.exports = __webpack_public_path__ + "static/media/lobbyM.bda1e1c9.jpg";